import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22618504"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "equal-height-panels row" };
const _hoisted_2 = { class: "columns" };
const _hoisted_3 = { class: "table-wrapper" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    key: 0,
    class: "is-empty-wrapper"
};
const _hoisted_6 = {
    key: 0,
    class: "columns detail-panel"
};
import NotificationFlash from "src/shared/v-components/ui/NotificationFlash.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    props: {
        isLoading: {},
        isEmpty: { type: Boolean },
        isDetailExpanded: { type: Boolean, default: false },
        tableLayout: { default: `auto` },
        className: { default: "panel-wrapper" }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.className)
            }, [
                _renderSlot(_ctx.$slots, "panel-header"),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("table", {
                                class: "table",
                                style: _normalizeStyle({ 'table-layout': _ctx.tableLayout, width: '100%' })
                            }, [
                                _createElementVNode("thead", null, [
                                    _renderSlot(_ctx.$slots, "thead")
                                ]),
                                (!_ctx.isLoading && !_ctx.isEmpty)
                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                                        _renderSlot(_ctx.$slots, "tbody")
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 4 /* STYLE */)
                        ]),
                        (_ctx.isEmpty && !_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _renderSlot(_ctx.$slots, "empty")
                            ]))
                            : _createCommentVNode("v-if", true),
                        (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(NotificationFlash, { key: 1 }))
                            : _createCommentVNode("v-if", true)
                    ]),
                    (_ctx.isDetailExpanded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _renderSlot(_ctx.$slots, "detail-panel")
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ], 2 /* CLASS */));
        };
    }
});
